var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-section"},[_c('ProviderSlider',{attrs:{"logos":_vm.logos}}),_c('ExpandableText',{attrs:{"title":"Casino 2025 — Best Real-Money Casino Games & €/\\$900 Bonus","fullText":_vm.description}}),_c('FooterNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }